import React from 'react';
import cn from 'classnames';
import CodeSquare from '@assets/img/code-square.svg';

function ContentItemEmpty({ className }) {
  return (
    <div className={cn('content-item__empty', className)}>
      <CodeSquare width={35} height={35} />
    </div>
  );
}

export default ContentItemEmpty;
